module.exports = {"demoURls":["demo","stgdemo","stgdemo1","stgdemo2"]}


//////////////////
// WEBPACK FOOTER
// ./src/shared/subDomainList.json
// module id = 385
// module chunks = 0